import lang from "@/views/modules/ApplicationEmails/language/en";
import Datepicker from 'vuejs-datepicker';
import CustomSearch from "@/views/modules/ApplicationEmails/SearchView.vue";
import vSelect from "vue-select";
import tinymce from 'vue-tinymce-text-editor';
import DownloadFile from "@/plugins/download_file.js";
import alert from "@/views/shared/notify/Alert.vue";

export default {
    name: "app-email-list",

    components: {
        Datepicker,
        CustomSearch,
        vSelect,
        'tinymce': tinymce,
        alert,
    },
    props: ['height'],
    data() {
        return {
            inbox:false,
            outbox:false,
            detail:false,
            detailData:{},
            color_array:[],
            userLogoColor:'',
            userLogo:'',
            userMail:'',
            inboxactive:'',
            outboxactive:'',
            page: 1,
            search: {

            },
            sort: {
                order: 'desc',
                column: 'date_modified',
            },
            perPage: 20,
            loading: true,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0
            },
            lang: [],
            emailList: [],
            sentList:[],
            usersList: [],
            dom_array: [],
            isActive:false,
            outbound:{
                email_template:"",
                application_id:"",
            },
            fileName: [],
            fileUpload: false,
            allFiles:[],
            processing:false,
            temlateList:[],
            options: {
                height: this.height || 350
            },
            file_error:'',
        }
    },
    mounted() {
        this.lang = lang;
        this.dom_array = this.domArrayVariable;
        this.inbox = true;
        this.inboxactive = 'active';
        this.getEmails();
        this.getUserList();
        this.getTemplate();
        this.color_array = this.domArrayVariable.Alphabetical_color;
    },
    methods: {
        changePage(page) {
            const self = this;
            if ((page > 0) && (page <= self.pagination.totalPages) && (page !== self.page)) {
                self.page = page;
                if(self.inbox == true){
                    self.getEmails();
                }
                if(self.outbox == true){
                    self.getSendMail();
                }
                
            }
        },
        changeSort() {
            const self = this;
            if (self.sort.order === 'asc') {
                self.sort.order = 'desc';
            } else if (self.sort.order === 'desc') {
                self.sort.order = 'asc';
            }
            if(self.inbox == true){
                self.getEmails();
            }
            if(self.outbox == true){
                self.getSendMail();
            }
        },
        getEmails() {
            const self = this;
            self.inbox = true;
            self.inboxactive = 'active';
            self.outbox = false;
            self.outboxactive = 'false';
            self.detail = false;
            self.outbound.application_id = self.$route.params.id;
            window.currentAction = 'list';
                axios.get('api/modules/applicationemails/inbox/'+self.$route.params.id, {
                params: {
                    page: self.page,
                    sort: self.sort,
                    search: self.search,
                    perPage: self.perPage
                }
            }).then(function (response) {
                
                self.emailList = response.data.items;
                self.pagination = response.data.pagination;
                if (self.pagination.totalPages < self.pagination.currentPage) {
                    self.page = self.pagination.totalPages;
                    self.getEmails();
                } else {
                    self.loading = false;
                }

            }).catch(function (error) {
                console.log(error);
            })
        },
        clearSearch() {
            const self = this;
            self.search = {};
            self.$emit('searchEvent', self.res)
            self.getEmails();
        },
        openAction() {
            this.isActive = !this.isActive;
        },
        showMailBody(text){
            const self = this;
            let onlyText = this.removeTags(text);
            
           /*  let searchText = '';
            if(self.inbox == true){
                searchText = document.getElementById('inbox_search').value;
            }
            if(self.outbox == true){
                searchText = document.getElementById('outbox_search').value;
            } */
            
            let firstTwentyWords = '';
           /*  if(searchText.length > 1 && searchText !=''){
                firstTwentyWords = onlyText.replace(searchText,"<span class='highlight-text'>"+searchText+"</span>").slice(0, 25); // create a sub-array of 20 words
            }else{ */
                firstTwentyWords = onlyText.slice(0, 20); // create a sub-array of 20 words
           // }
            
            return firstTwentyWords+"...";
        },
        getUserList() {
            const self = this;
            window.currentAction = 'detail';
            axios.post('api/modules/users/select').then(function (response) {
               // self.usersList = response.data.items;

                self.usersList = response.data.items.map(item => ({
                    id: item.id,
                    uemail: `${item.name} (${item.email})`,
                    email: item.email,
                }));
            })
        },
        sendMail(){
            const self = this;
            //self.disabled = true;
                self.processing = true;
            axios.post('api/modules/applicationemails/unread/sendmail', {'formData':self.outbound,'filelist': self.allFiles, headers: { 'Content-Type': 'multipart/form-data' }}).then(function(res){
                self.disabled = false;
                self.processing = false;
                if(res.data.message !=''){
                    self.$refs.notifyMsg.showAlert('Success',res.data.message);
                    self.outbound = {};
                    document.getElementById('uploadFiles').value = '';
                    $("#composeMail").modal("hide");
                    self.getEmails();
                }
                 }).catch(function () {
                self.loading = false;
                });
        },
        getSendMail(){
            const self= this;

            self.inbox = false;
            self.inboxactive = '';
            self.outbox = true;
            self.outboxactive = 'active';
            self.detail = false;
            window.currentAction = 'list';
                axios.get('api/modules/applicationemails/outbox/'+self.$route.params.id, {
                params: {
                    page: self.page,
                    sort: self.sort,
                    search: self.search,
                    perPage: self.perPage
                }
            }).then(function(response){
                self.sentList = response.data.items;
                self.pagination = response.data.pagination;
                if (self.pagination.totalPages < self.pagination.currentPage) {
                    self.page = self.pagination.totalPages;
                    self.getSendMail();
                } else {
                    self.loading = false;
                }

            }).catch(function(){
                self.loading = false;
            })
        },
        removeTags(str){
            if ((str===null) || (str===''))
                return false;
            else
                str = str.toString();
            
            // HTML tag with a null string.
            return str.replace( /(<([^>]+)>)/ig, '');
        },
        /*================ open mail detail ============================*/
        openMail(mailid, mail_type){
            const self = this;
            self.detailData = {};
            if(mailid !='' && mail_type == 'inbox')
            {
                self.inbox = false;
                self.detail = true;
                window.currentAction = 'list';
                axios.get('api/modules/applicationemails/inboxmail', {params:{'mail_id':mailid, 'mailType':'inboxMail'}}).then(function(response){
                    self.detailData = response.data.items;
                    self.showLogoColor(self.detailData);
                }).catch(function(){
                    self.loading = false;
                });
            }

            if(mailid !='' && mail_type == 'outbox')
            {
                self.outbox = false;
                self.detail = true;
                window.currentAction = 'list';
                axios.get('api/modules/applicationemails/outboxmail', {params:{'mail_id':mailid, 'mailType':'outboxMail'}}).then(function(response){
                    self.detailData = response.data.items;
                    self.showLogoColor(self.detailData);
                }).catch(function(){
                    self.loading = false;
                });
            }
           
        },
        showAttachment(file_name){
            let filesArr = file_name.split("_");
                filesArr.splice(0, 1);
           
            return filesArr.join("");
        },
        downloadFile(fileLocation, filename){
            const filepath = new DownloadFile();
            let url = filepath.getFilePath(fileLocation, filename);
            window.open(url, '_blank');
        },
        showLogoColor(mailData){
            const self = this;
            let username = mailData[0].fromname;
            let colorCode = '';
            
            if(username !='' && username != null){                
                colorCode = username[0];
                self.userLogo = colorCode;
                self.userMail = mailData[0].fromaddress;
            }else{
                let usermail = mailData[0].to;
                colorCode = usermail[0].toUpperCase();
                self.userLogo = colorCode;
                self.userMail = mailData[0].to;
            }
            
            self.userLogoColor = 'background: '+self.color_array[colorCode];
        },
        searchMail(event, mailType){
            const self = this;
            let custom_search = {
                'search_value':event.target.value
            }
            axios.get(`api/modules/applicationemails/${mailType}/${self.$route.params.id}`, {
                params: {
                    page: self.page,
                    sort: self.sort,
                    search: self.search,
                    custom_search: custom_search,
                    perPage: self.perPage
                }
            }).then(function(response){
                if(mailType == 'inbox'){
                    self.emailList = response.data.items;
                    self.pagination = response.data.pagination;
                    if (self.pagination.totalPages < self.pagination.currentPage) {
                        self.page = self.pagination.totalPages;
                        self.getEmails();
                    } else {
                        self.loading = false;
                    }
                }

            if(mailType == 'outbox'){
                    self.sentList = response.data.items;
                    self.pagination = response.data.pagination;
                    if (self.pagination.totalPages < self.pagination.currentPage) {
                        self.page = self.pagination.totalPages;
                        self.getSendMail();
                    } else {
                        self.loading = false;
                    }
                }
                
            }).catch(function(){
                self.loading = false;
            })
        },
        getTemplate(){
            const self = this;
            window.currentAction = 'list';
                axios.get('api/modules/emailtemplates').then(function(response){
                //console.log(response);
                self.temlateList = response.data.items;
            }).catch(function(e){
                self.loading = false;
            })
        },
        updateTemplate(event){
            const self = this;
          
            let mbody = document.getElementById("mailBody");
            //console.log(self.temlateList[event.target.value].template_text);
            self.outbound.mailbody = self.temlateList[event.target.value].template_text;
           
        },
        removeMail(mailId, mailType){
            const self = this;
            const deleteRecord = {'delete_id':mailId, 'mailType':mailType};
            axios.post('api/modules/applicationemails/remove', deleteRecord).then(function(response){
                self.getEmails();
            }).catch(function(error){
                self.loading = false;
            });
        }
    },
}